
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { CabecalhoDTO } from 'src/app/entity/dto/cabecalho.component';
import { EnumForm } from 'src/app/entity/enum/enum-form';
import { EnumFormType } from 'src/app/entity/enum/enum-form-type';
import { FormRs005 } from './../../entity/forms/form-rs005';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Rs005CardIComponent } from './partialViews/rs005-card-I.component'
import { Rs005CardIIComponent } from './partialViews/rs005-card-II.component'
import { Rs005CardIIIComponent } from './partialViews/rs005-card-III.component'
import { Rs005CardIVComponent } from './partialViews/rs005-card-IV.component'
import { Rs005CardVComponent } from './partialViews/rs005-card-V.component'
import { Rs005CardVIComponent } from './partialViews/rs005-card-VI.component'
import { Rs005CardVIIComponent } from './partialViews/rs005-card-VII.component'
import { Rs005CardVIIIComponent } from './partialViews/rs005-card-VIII.component'
import { Rs005CardXComponent } from './partialViews/rs005-card-X.component'
import { Rs005CardXIComponent } from './partialViews/rs005-card-XI.component'
// import { Rs005CardIXComponent } from './partialViews/rs005-card-IX.component'
import { HttpErrorResponse } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { Rs005CardIXComponent } from './partialViews/rs005-card-IX.component';
import { FormModalConfirmComponent } from 'src/app/shared/form-modal-confirm/form-modal-confirm.component';
import { MatDialog } from '@angular/material/dialog';
import { ResumeAllFormsService } from 'src/app/services/resume-all-forms.service';
import { Rs005CardXIIComponent } from './partialViews/rs005-card-XII.component';
import { Rs005SourceItem } from 'src/app/entity/models/rs005-list-source';
import { Rs005CardXIVComponent } from './partialViews/rs005-card-XIV.component';
import { Rs005CardXIIIComponent } from './partialViews/rs005-card-XIII.component';

@Component({
  selector: 'app-form-rs005',
  templateUrl: './form-rs005.component.html'
})

export class FormRs005Component implements OnInit, AfterViewInit {

  public areaSelect: string = localStorage.getItem('area-select') || null;
  public header?: CabecalhoDTO;
  public formulario?: FormGroup;
  public btnCollapse?: boolean;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public enableButtons = this.loadingSubject.asObservable();
  public showButtonSync = false;
  public formRs005: FormRs005 = new FormRs005();
  valuesInitial: any;
  valoresAlterados: any[] = [];
  currentUser: string = "";

  @ViewChild(Rs005CardIComponent, { static: false }) rs005CardIComponent: Rs005CardIComponent;
  @ViewChild(Rs005CardIIComponent, { static: false }) rs005CardIIComponent: Rs005CardIIComponent;
  @ViewChild(Rs005CardIIIComponent, { static: false }) rs005CardIIIComponent: Rs005CardIIIComponent;
  @ViewChild(Rs005CardIVComponent, { static: false }) rs005CardIVComponent: Rs005CardIVComponent;
  @ViewChild(Rs005CardVComponent, { static: false }) rs005CardVComponent: Rs005CardVComponent;
  @ViewChild(Rs005CardVIComponent, { static: false }) rs005CardVIComponent: Rs005CardVIComponent;
  @ViewChild(Rs005CardVIIComponent, { static: false }) rs005CardVIIComponent: Rs005CardVIIComponent;
  @ViewChild(Rs005CardVIIIComponent, { static: false }) rs005CardVIIIComponent: Rs005CardVIIIComponent;
  @ViewChild(Rs005CardIXComponent, { static: false }) rs005CardIXComponent: Rs005CardIXComponent;
  @ViewChild(Rs005CardXComponent, { static: false }) rs005CardXComponent: Rs005CardXComponent;
  @ViewChild(Rs005CardXIComponent, { static: false }) rs005CardXIComponent: Rs005CardXIComponent;
  @ViewChild(Rs005CardXIIComponent, { static: false }) rs005CardXIIComponent: Rs005CardXIIComponent;
  @ViewChild(Rs005CardXIIIComponent, { static: false }) rs005CardXIIIComponent: Rs005CardXIIIComponent;
  @ViewChild(Rs005CardXIVComponent, { static: false }) rs005CardXIVComponent: Rs005CardXIVComponent;
  DashboardComponent: any;
  id: number;

  // tslint:disable-next-line: max-line-length
  constructor(protected formBuilder: FormBuilder, protected generalService: GeneralService, protected notificationService: NotificationService, protected formularioService: FormularioService, protected route: ActivatedRoute, protected resumeAllFormsService: ResumeAllFormsService, public dialog: MatDialog) {
    this.header = new CabecalhoDTO();
    this.formulario = this.formRs005.CreateForm(formBuilder);
  }

  ngAfterViewInit(): void {
    this.route.data.subscribe(async (data: any) => {
      if (!!data) {
        this.valuesInitial = data?.formulario ?? this.formulario.getRawValue();;
        const type = (this.route?.snapshot?.params?.type);
        const isReadOnly: boolean = type === '2' ? true : false;
        this.loadingSubject.next(isReadOnly ? false : true);
        if (type === '1' || type === '2') {
          const formType = type === '1' ? EnumFormType.Edit : EnumFormType.Details;
          const formHeader = this.generalService.isComercial || this.generalService.isBasica
            ? EnumForm.FormRs005
            : EnumForm.FormRs005PreBasica;

          this.header = this.generalService.createHeader(formHeader, formType);
          await this.updateForm(data);
          await this.enableGranacao();
          await this.validateCerar();
          this.enableNovoNumeroCaixa();
          if (this.areaSelect.includes('Pré-Básica')) {
            this.createSourceCardIItemCompoment(data);
            this.setIsG0();
          }
        } else {
          this.valoresAlterados = this.formulario.getRawValue()

          const formHeader = this.generalService.isComercial || this.generalService.isBasica
            ? EnumForm.FormRs005
            : EnumForm.FormRs005PreBasica;

          this.header = this.generalService.createHeader(formHeader, EnumFormType.New);

          await this.getUser();
          if (!this.areaSelect.includes('Pré-Básica')) {
            this.rs005CardIComponent.formulario.get('Site_recebimento').setValue(this.generalService.getLocalStorageDataSite());
          }
          else {
            this.rs005CardIComponent.formulario.get('site_recebimento').setValue(this.generalService.getLocalStorageDataSite());
          }
          await this.enableGranacao();
          // await this.validateCerar();
          this.fillCreatedByFormField();
        }
      }
    });
  }

  ngOnInit(): void {

    const formHeader = this.generalService.isComercial || this.generalService.isBasica
      ? EnumForm.FormRs005
      : EnumForm.FormRs005PreBasica;

    this.header = this.generalService.createHeader(formHeader, EnumFormType.New);

    this.btnCollapse = true;
    this.loadingSubject.next(false);
    this.enableGranacao();
    // this.validateCerar();
  }

  async save(): Promise<void> {
    const id: number = this.formulario.get('id').value as number;
    const isAddFlow = id === 0;

    if (await this.validFormsToSave() === '') {
      await this.buildFormulario();
      if (this.areaSelect.includes('Pré-Básica')) {
        this.buildListSource(id);
      }
      await this.resumeAllFormsService.compareAdd(this.valuesInitial, this.formulario.getRawValue(), isAddFlow, 'rs005');

      // CHAMAR MODAL DE CONFIRMACAO

      this.openConfirmDialog(this.resumeAllFormsService.valoresAlterados, isAddFlow);
    }
  }

  public async openConfirmDialog(valoresAlterados: any[], isAddFlow): Promise<void> {

    const values: any[] = valoresAlterados;

    const dialogRef = this.dialog.open(FormModalConfirmComponent, {
      data: {
        valoresAlterados: values,
        isAddFlow
      }

    });
    dialogRef.afterClosed().subscribe(x => {
      if (x.save) {

        const id: number = this.formulario.get('id').value as number;
        this.formularioService.saveForm(id, this.formulario.getRawValue(), 'rs005', 'formrs005');
      }
      else {
        this.resumeAllFormsService.valoresAlterados = []
      }

    })

  }

  async getForms(): Promise<FormGroup[]> {
    const arrForms: Array<FormGroup> = new Array<FormGroup>();
    arrForms.push(this.rs005CardIComponent.formulario);
    arrForms.push(this.rs005CardIIComponent.formulario);
    arrForms.push(this.rs005CardIIIComponent.formulario);
    arrForms.push(this.rs005CardIVComponent.formulario);
    arrForms.push(this.rs005CardVComponent.formulario);
    arrForms.push(this.rs005CardVIComponent.formulario);
    arrForms.push(this.rs005CardVIIComponent.formulario);
    arrForms.push(this.rs005CardVIIIComponent.formulario);
    arrForms.push(this.rs005CardIXComponent.formulario);
    arrForms.push(this.rs005CardXComponent.formulario);
    arrForms.push(this.rs005CardXIComponent.formulario);
    arrForms.push(this.rs005CardXIIComponent.formulario);
    arrForms.push(this.rs005CardXIIIComponent.formulario);
    arrForms.push(this.rs005CardXIVComponent.formulario);


    return await arrForms;
  }

  async validFormsToSave(): Promise<string> {
    return await this.formularioService.validForm(await this.getForms());
  }

  async cleanAll(): Promise<void> {
    if (this.header.ScreenType === this.generalService.getEnumFormType(
      EnumFormType.New)) {
      await this.formularioService.cleanForm(await this.getForms());
      await this.getUser();
      this.rs005CardIComponent.formulario.get('Site_recebimento').setValue(this.generalService.getLocalStorageDataSite());
    } else {
      const usuario: string = this.rs005CardIXComponent.formulario.get('Responsavel_lancamento')?.value;
      await this.formularioService.cleanForm(await this.getForms());
      this.rs005CardIXComponent.formulario.get('Responsavel_lancamento')?.setValue(usuario);
    }
  }

  async collapseAll(): Promise<void> {
    this.btnCollapse = this.btnCollapse ? false : true;
    this.rs005CardIComponent.collapseCard = this.btnCollapse ? false : true;
    this.rs005CardIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.rs005CardIIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.rs005CardIVComponent.collapseCard = this.btnCollapse ? false : true;
    this.rs005CardVComponent.collapseCard = this.btnCollapse ? false : true;
    this.rs005CardVIComponent.collapseCard = this.btnCollapse ? false : true;
    this.rs005CardVIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.rs005CardVIIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.rs005CardIXComponent.collapseCard = this.btnCollapse ? false : true;
    this.rs005CardXIIComponent.collapseCard = this.btnCollapse ? false : true;
  }

  public async buildFormulario(): Promise<void> {
    this.formulario = await this.formRs005.buildForm(this.formulario, await this.getForms(), this.generalService);
  }

  public async updateForm(data?: any): Promise<void> {
    this.formulario.get('id').setValue(data.formulario.id);
    this.id = data.formulario.id;
    if (data.formulario.hasOwnProperty('offline')) {
      this.formulario.get('offline').setValue(true);
    }

    this.rs005CardIComponent.disableNumeroCampo = true;
    this.rs005CardIComponent.safraBasicaOld = data.formulario.safra_basica;
    this.rs005CardIIComponent.pesoPosSecagem = data.formulario.peso_pos_secagem;

    await this.formRs005.updateForm(data, await this.getForms(), this.generalService);
  }

  // INICIO DO CODIGO DE CALCULO

  private async validateCerar(): Promise<void> {

    if (!this.areaSelect.includes('Pré-Básica')) {
      const siteRecebimento = this.rs005CardIComponent.formulario.get('Site_recebimento')?.value as string;
      console.log(`siteRecebimento: ${siteRecebimento}`);

      const siteCerar = this.rs005CardIComponent.formulario.get('Cerar');
      const keysCerar = Object.keys(siteCerar);
      console.log(keysCerar);
      console.log(`cerar:${typeof siteCerar}`);
    }
  }

  private enableNovoNumeroCaixa() {
    if (this.areaSelect.includes('Pré-Básica') && this.rs005CardIComponent.formulario?.get('houve_troca_caixa').value === 'SIM') {
      this.rs005CardIComponent.isNovaCaixa = true;
    }
  }

  private async enableGranacao(): Promise<void> {
    if (!this.areaSelect.includes('Pré-Básica')) {
      const siteRecebimento = this.rs005CardIComponent.formulario.get('Site_recebimento')?.value as string;
      console.log(siteRecebimento);
      //const isComercialContract = contratoJuridico.toUpperCase().includes('M');
      //const site_recebimento: string = this.qua007CardIComponent.formulario.get('Site_recebimento')?.value?.toUpperCase() ?? '';
      //const site_origem: string = this.qua007CardIComponent.formulario.get('Site_origem')?.value?.toUpperCase() ?? '';
      if (siteRecebimento == 'CDR' || siteRecebimento === 'PTU-BÁSICA') {
        this.rs005CardIIComponent.readOnlyGranacao = false;
        //this.validatorRequired(true);
        // } else if (site_origem === 'CDR' && site_recebimento !== 'PTU-BÁSICA') {
        //     this.qua007CardIIComponent.readyOnlyUmidade = false;
        //     this.validatorRequired(true);
        // } else if (site_origem === 'CDR' && site_recebimento === 'PTU-BÁSICA') {
        //     this.qua007CardIIComponent.readyOnlyUmidade = false;
        //     this.validatorRequired(true);
      } else {
        this.rs005CardIIComponent.readOnlyGranacao = true;
        //this.validatorRequired(false);
      }
    }

  }

  // private async validatorRequired(blRequired?: boolean): Promise<void> {
  //     if (blRequired) {
  //         //this.qua007CardIComponent.formulario.get('Gleba').reset();
  //         this.qua007CardIComponent.formulario.get('Gleba').setValidators([Validators.required]);
  //     } else {
  //         this.qua007CardIComponent.formulario.get('Gleba').setValidators([]);
  //         this.qua007CardIComponent.formulario.get('Gleba').reset();
  //     }
  //     this.qua007CardIComponent.formulario.get('Gleba').updateValueAndValidity()
  // }

  public async makeCalculations(event?: any): Promise<void> {
    //Card-II
    await this.getTotalEspigasGranacao();
    await this.getGranacaoMedia();
    //Card-III
    await this.getPesoAmostra();
    await this.getPalhaCerar();
    await this.getSabugoCerar();
    await this.getSementeCerar();
    await this.getPalhaAmostra();
    await this.getTotalGraosPerdidosAmostra();
    await this.getPerdaPorEspigasInteiras();
    //Card-IV
    await this.getPesoPalhaCarga();
    await this.getPesoLiqCargaUmidade();
    await this.getPerdaProcesso();
    await this.getPesoEspigasPerdidasInteiras();
    //Card-V
    await this.getPerdaEspigasInteiras();
    await this.getPerdaTotalDespalha();
    await this.getPerdaGraosDebulhadosDespalha();
    //Card-VI
    await this.getEspigasDespalhadasRetorno();
    await this.getEspigasPalhaMesa();
    // //Card-VII
    await this.getPesoLiqCargaSPalha();
    await this.getPesoDescarteMesaSelecao();
    await this.getDescarteMesaSelecao();
    await this.getEspigasAtipicas();
    // //Card-VIII
    await this.getDespalha();
    //await this.getEspigasPalha();

    // //Card-X
    await this.getMortePrematuraPrc();

    // //Card-XI
    await this.getOutrosDefeitosPrc();
  }

  private async getTotalEspigasGranacao(): Promise<void> {
    const granacao_100: number = (this.rs005CardIIComponent.formulario.get('Granacao_100').value);
    const granacao_75: number = (this.rs005CardIIComponent.formulario.get('Granacao_75').value);
    const granacao_50: number = (this.rs005CardIIComponent.formulario.get('Granacao_50').value);
    const granacao_25: number = (this.rs005CardIIComponent.formulario.get('Granacao_25').value);
    const granacao_0: number = (this.rs005CardIIComponent.formulario.get('Granacao_0').value);
    if (!!granacao_100 || !!granacao_75 || !!granacao_50 || !!granacao_25 || !!granacao_0) {
      const resultado: number = (granacao_100 + granacao_75 + granacao_50 + granacao_25 + granacao_0);
      this.rs005CardIIComponent.formulario.get('Total_espigas_granacao').setValue(resultado);
    }
    // const resultado: number = granacao_100 + granacao_75 + granacao_50 + granacao_25 + granacao_0;
    // this.rs005CardIIComponent.formulario.get('Total_espigas_granacao').setValue(resultado);
  }

  private async getGranacaoMedia(): Promise<void> {
    let granacao_100: number = !!this.rs005CardIIComponent.formulario.get('Granacao_100').value ? (this.rs005CardIIComponent.formulario.get('Granacao_100')?.value as number ?? 0) : 0;
    let granacao_75: number = !!this.rs005CardIIComponent.formulario.get('Granacao_75').value ? (this.rs005CardIIComponent.formulario.get('Granacao_75')?.value as number ?? 0) : 0;
    let granacao_50: number = !!this.rs005CardIIComponent.formulario.get('Granacao_50').value ? (this.rs005CardIIComponent.formulario.get('Granacao_50')?.value as number ?? 0) : 0;
    let granacao_25: number = !!this.rs005CardIIComponent.formulario.get('Granacao_25').value ? (this.rs005CardIIComponent.formulario.get('Granacao_25')?.value as number ?? 0) : 0;
    let granacao_0: number = !!this.rs005CardIIComponent.formulario.get('Granacao_0').value ? (this.rs005CardIIComponent.formulario.get('Granacao_0')?.value as number ?? 0) : 0;
    const total_espigas_granacao: number = !!this.rs005CardIIComponent.formulario.get('Total_espigas_granacao').value ? (this.rs005CardIIComponent.formulario.get('Total_espigas_granacao')?.value as number ?? 0) : 0;
    let resultado: number = 0;
    if (!!granacao_100 || !!granacao_75 || !!granacao_50 || !!granacao_25 || !!granacao_0) {
      granacao_100 = granacao_100 * 1;
      granacao_75 = granacao_75 * 0.75;
      granacao_50 = granacao_50 * 0.5;
      granacao_25 = granacao_25 * 0.25;
      granacao_0 = granacao_0 * 0;

      if (total_espigas_granacao > 0) {
        resultado = this.generalService.CalcPorc((granacao_100 + granacao_75 + granacao_50 + granacao_25), total_espigas_granacao);
      } else {
        resultado = 0;
      }
      this.rs005CardIIComponent.formulario.get('Granacao_media').setValue(resultado);
    }
    // granacao_100 = granacao_100 * 1;
    // granacao_75 = granacao_75 * 0.75;
    // granacao_50 = granacao_50 * 0.5;
    // granacao_25 = granacao_25 * 0.25;
    // granacao_0 = granacao_0 * 0;

    // if (total_espigas_granacao > 0) {
    //     resultado = this.generalService.CalcPorc((granacao_100 + granacao_75 + granacao_50 + granacao_25), total_espigas_granacao);
    // } else {
    //     resultado = 0;
    // }
    // this.rs005CardIIComponent.formulario.get('Granacao_media').setValue(resultado);
  }


  private async getPesoAmostra(): Promise<void> {

    const status_wwb: string = this.rs005CardIIIComponent.formulario.get('Status_wwb').value as string ?? '';
    let peso_palha_imp_g: number = !!this.rs005CardIIIComponent.formulario.get('Peso_palha_imp_g').value ? this.rs005CardIIIComponent.formulario.get('Peso_palha_imp_g')?.value as number ?? 0 : 0;
    const peso_graos_debulhados_g: number = !!this.rs005CardIIIComponent.formulario.get('Peso_graos_debulhados_g').value ? this.rs005CardIIIComponent.formulario.get('Peso_graos_debulhados_g')?.value as number ?? 0 : 0;
    const peso_graos_espigas_inteiras_g: number = !!this.rs005CardIIIComponent.formulario.get('Peso_graos_espigas_inteiras_g').value ? this.rs005CardIIIComponent.formulario.get('Peso_graos_espigas_inteiras_g')?.value as number ?? 0 : 0;
    const arrStatusWwb: string[] = ['MQ', 'MF'];
    let resultado: number = 0;

    if (arrStatusWwb.includes(status_wwb)) {
      peso_palha_imp_g = peso_palha_imp_g * 1.15;
      resultado = peso_palha_imp_g + peso_graos_debulhados_g + peso_graos_espigas_inteiras_g;
    } else {
      resultado = peso_palha_imp_g + peso_graos_debulhados_g + peso_graos_espigas_inteiras_g;
    }

    this.rs005CardIIIComponent.formulario.get('Peso_amostra_g').setValue(resultado);
  }

  private async getPalhaCerar(): Promise<void> {
    const peso_palha_cooperante_g: number = !!this.rs005CardIComponent.formulario.get('Peso_palha_cooperante_g').value ? (this.rs005CardIComponent.formulario.get('Peso_palha_cooperante_g')?.value as number ?? 0) : 0;
    const peso_amostra_cooperante_g: number = !!this.rs005CardIComponent.formulario.get('Peso_amostra_cooperante_g').value ? (this.rs005CardIComponent.formulario.get('Peso_amostra_cooperante_g')?.value as number ?? 0) : 0;
    const peso_impureza_cooperante_g: number = !!this.rs005CardIComponent.formulario.get('Peso_impureza_cooperante_g').value ? (this.rs005CardIComponent.formulario.get('Peso_impureza_cooperante_g')?.value as number ?? 0) : 0;

    let resultado: number = 0;

    if (peso_amostra_cooperante_g > 0) {
      resultado = this.generalService.CalcPorc(peso_palha_cooperante_g + peso_impureza_cooperante_g, peso_amostra_cooperante_g);
    } else {
      resultado = 0;
    }

    this.rs005CardIIIComponent.formulario.get('Palha_cerar').setValue(resultado);
  }

  private async getMortePrematuraPrc(): Promise<void> {
    const total_espigas_morte_prematura: number = !!this.rs005CardXComponent.formulario.get('total_espigas_morte_prematura').value ? (this.rs005CardXComponent.formulario.get('total_espigas_morte_prematura')?.value as number ?? 0) : 0;
    const total_espigas_granacao: number = !!this.rs005CardIIComponent.formulario.get('Total_espigas_granacao').value ? (this.rs005CardIIComponent.formulario.get('Total_espigas_granacao')?.value as number ?? 0) : 0;

    let resultado: number = 0;

    if (total_espigas_morte_prematura > 0) {
      resultado = this.generalService.CalcPorc(total_espigas_morte_prematura, total_espigas_granacao);
    } else {
      resultado = 0;
    }

    this.rs005CardXComponent.formulario.get('morte_prematura_prc').setValue(resultado);
  }

  private async getOutrosDefeitosPrc(): Promise<void> {
    const total_espigas_outros_defeitos: number = !!this.rs005CardXIComponent.formulario.get('total_espigas_outros_defeitos').value ? (this.rs005CardXIComponent.formulario.get('total_espigas_outros_defeitos')?.value as number ?? 0) : 0;
    const total_espigas_granacao: number = !!this.rs005CardIIComponent.formulario.get('Total_espigas_granacao').value ? (this.rs005CardIIComponent.formulario.get('Total_espigas_granacao')?.value as number ?? 0) : 0;

    let resultado: number = 0;

    if (total_espigas_outros_defeitos > 0) {
      resultado = this.generalService.CalcPorc(total_espigas_outros_defeitos, total_espigas_granacao);
    } else {
      resultado = 0;
    }

    this.rs005CardXIComponent.formulario.get('outros_defeitos_prc').setValue(resultado);
  }

  private async getSabugoCerar(): Promise<void> {
    const peso_sabugo_cooperante_g: number = !!this.rs005CardIComponent.formulario.get('Peso_sabugo_cooperante_g').value ? (this.rs005CardIComponent.formulario.get('Peso_sabugo_cooperante_g')?.value as number ?? 0) : 0;
    const peso_amostra_cooperante_g: number = !!this.rs005CardIComponent.formulario.get('Peso_amostra_cooperante_g').value ? (this.rs005CardIComponent.formulario.get('Peso_amostra_cooperante_g')?.value as number ?? 0) : 0;
    let resultado: number = 0;
    if (peso_amostra_cooperante_g > 0) {
      resultado = this.generalService.CalcPorc(peso_sabugo_cooperante_g, peso_amostra_cooperante_g);
    } else {
      resultado = 0;
    }
    this.rs005CardIIIComponent.formulario.get('Sabugo_cerar').setValue(resultado);
  }

  private async getSementeCerar(): Promise<void> {
    const peso_semente_cooperante_g: number = !!this.rs005CardIComponent.formulario.get('Peso_semente_cooperante_g').value ? (this.rs005CardIComponent.formulario.get('Peso_semente_cooperante_g')?.value as number ?? 0) : 0;
    const peso_amostra_cooperante_g: number = !!this.rs005CardIComponent.formulario.get('Peso_amostra_cooperante_g').value ? (this.rs005CardIComponent.formulario.get('Peso_amostra_cooperante_g')?.value as number ?? 0) : 0;
    let resultado: number = 0;

    if (peso_amostra_cooperante_g > 0) {
      resultado = this.generalService.CalcPorc(peso_semente_cooperante_g, peso_amostra_cooperante_g);
    } else {
      resultado = 0;
    }
    this.rs005CardIIIComponent.formulario.get('Semente_cerar').setValue(resultado);
  }

  private async getPalhaAmostra(): Promise<void> {
    const status_wwb: string = this.rs005CardIIIComponent.formulario.get('Status_wwb').value;
    const peso_palha_imp_g: number = !!this.rs005CardIIIComponent.formulario.get('Peso_palha_imp_g').value ? (this.rs005CardIIIComponent.formulario.get('Peso_palha_imp_g')?.value as number ?? 0) : 0;
    let peso_amostra_g: number = !!this.rs005CardIIIComponent.formulario.get('Peso_amostra_g').value ? (this.rs005CardIIIComponent.formulario.get('Peso_amostra_g')?.value as number ?? 0) : 0;
    const arrStatusWwb: string[] = ['MQ', 'MF'];
    let resultado: number = 0;

    if (arrStatusWwb.includes(status_wwb) && peso_amostra_g > 0) {
      peso_amostra_g = peso_amostra_g * 1.15;
      resultado = this.generalService.CalcPorc(peso_palha_imp_g, peso_amostra_g);
    } else if (peso_amostra_g > 0) {
      resultado = this.generalService.CalcPorc(peso_palha_imp_g, peso_amostra_g);
    }

    this.rs005CardIIIComponent.formulario.get('Palha_amostra').setValue(resultado);
  }

  private async getTotalGraosPerdidosAmostra(): Promise<void> {
    const status_wwb: string = this.rs005CardIIIComponent.formulario.get('Status_wwb').value;
    const peso_graos_debulhados_g: number = !!this.rs005CardIIIComponent.formulario.get('Peso_graos_debulhados_g').value ? (this.rs005CardIIIComponent.formulario.get('Peso_graos_debulhados_g')?.value as number ?? 0) : 0;
    const peso_graos_espigas_inteiras_g: number = !!this.rs005CardIIIComponent.formulario.get('Peso_graos_espigas_inteiras_g').value ? (this.rs005CardIIIComponent.formulario.get('Peso_graos_espigas_inteiras_g')?.value as number ?? 0) : 0;
    const peso_palha_imp_g: number = !!this.rs005CardIIIComponent.formulario.get('Peso_palha_imp_g').value ? (this.rs005CardIIIComponent.formulario.get('Peso_palha_imp_g')?.value as number ?? 0) : 0;
    const arrStatusWwb: string[] = ['MQ', 'MF'];
    let resultado: number = 0;

    if (arrStatusWwb.includes(status_wwb) && peso_palha_imp_g > 0) {
      resultado = this.generalService.CalcPorc(1.15 * (peso_graos_debulhados_g + peso_graos_espigas_inteiras_g), peso_palha_imp_g);
    } else if (peso_palha_imp_g > 0) {
      resultado = this.generalService.CalcPorc(peso_graos_debulhados_g + peso_graos_espigas_inteiras_g, peso_palha_imp_g);
    }

    this.rs005CardIIIComponent.formulario.get('Total_graos_perdidos_amostra').setValue(resultado);
  }

  private async getPerdaPorEspigasInteiras(): Promise<void> {
    const peso_graos_espigas_inteiras_g: number = !!this.rs005CardIIIComponent.formulario.get('Peso_graos_espigas_inteiras_g').value ? (this.rs005CardIIIComponent.formulario.get('Peso_graos_espigas_inteiras_g')?.value as number ?? 0) : 0;
    const peso_amostra_g: number = !!this.rs005CardIIIComponent.formulario.get('Peso_amostra_g').value ? (this.rs005CardIIIComponent.formulario.get('Peso_amostra_g')?.value as number ?? 0) : 0;
    let resultado: number = null;

    if (peso_amostra_g > 0) {
      resultado = this.generalService.CalcPorc(peso_graos_espigas_inteiras_g, peso_amostra_g);
    }

    this.rs005CardIIIComponent.formulario.get('Perda_por_espigas_inteiras').setValue(resultado);
  }

  private async getPesoPalhaCarga(): Promise<void> {
    const peso_liq_carga_cooperante_kg: number = !!this.rs005CardIComponent.formulario.get('Peso_liq_carga_cooperante_kg').value ? (this.rs005CardIComponent.formulario.get('Peso_liq_carga_cooperante_kg')?.value as number ?? 0) : 0;
    const palha_cerar: number = !!this.rs005CardIIIComponent.formulario.get('Palha_cerar').value ? (this.rs005CardIIIComponent.formulario.get('Palha_cerar')?.value as number ?? 0) : 0;
    let resultado: number = null;
    resultado = (peso_liq_carga_cooperante_kg * palha_cerar) / 100;
    this.rs005CardIVComponent.formulario.get('Peso_palha_carga_kg').setValue(resultado);
  }

  private async getPesoLiqCargaUmidade(): Promise<void> {
    const peso_liq_carga_cooperante_kg: number = !!this.rs005CardIComponent.formulario.get('Peso_liq_carga_cooperante_kg').value ? (this.rs005CardIComponent.formulario.get('Peso_liq_carga_cooperante_kg')?.value as number ?? 0) : 0;
    const semente_cerar: number = !!this.rs005CardIIIComponent.formulario.get('Semente_cerar').value ? (this.rs005CardIIIComponent.formulario.get('Semente_cerar')?.value as number ?? 0) : 0;
    let resultado: number = null;
    resultado = peso_liq_carga_cooperante_kg * semente_cerar / 100;
    this.rs005CardIVComponent.formulario.get('Peso_liquido_carga_umidade_kg').setValue(resultado);
  }

  private async getPerdaProcesso(): Promise<void> {
    const peso_palha_carga_kg: number = !!this.rs005CardIVComponent.formulario.get('Peso_palha_carga_kg').value ? (this.rs005CardIVComponent.formulario.get('Peso_palha_carga_kg')?.value as number ?? 0) : 0;
    const total_graos_perdidos_amostra: number = !!this.rs005CardIIIComponent.formulario.get('Total_graos_perdidos_amostra').value ? (this.rs005CardIIIComponent.formulario.get('Total_graos_perdidos_amostra')?.value as number ?? 0) : 0;
    let resultado: number = null;

    if (peso_palha_carga_kg > 0 && total_graos_perdidos_amostra > 0) {
      resultado = peso_palha_carga_kg * total_graos_perdidos_amostra / 100;
    }

    this.rs005CardIVComponent.formulario.get('Perda_processo_kg').setValue(resultado);
  }

  private async getPesoEspigasPerdidasInteiras(): Promise<void> {
    const perda_por_espigas_inteiras_porc: number = !!this.rs005CardIIIComponent.formulario.get('Perda_por_espigas_inteiras').value ? (this.rs005CardIIIComponent.formulario.get('Perda_por_espigas_inteiras')?.value as number ?? 0) : 0;
    const peso_palha_carga_kg: number = !!this.rs005CardIVComponent.formulario.get('Peso_palha_carga_kg').value ? (this.rs005CardIVComponent.formulario.get('Peso_palha_carga_kg')?.value as number ?? 0) : 0;
    let resultado: number = null;

    if (perda_por_espigas_inteiras_porc > 0 && peso_palha_carga_kg > 0) {
      resultado = perda_por_espigas_inteiras_porc * peso_palha_carga_kg / 100;
    } else if (perda_por_espigas_inteiras_porc >= 0 && peso_palha_carga_kg === 0) {
      resultado = 0;
    } else if (peso_palha_carga_kg >= 0 && perda_por_espigas_inteiras_porc === 0) {
      resultado = 0;
    }

    this.rs005CardIVComponent.formulario.get('Peso_espigas_inteiras_perdidas_kg').setValue(resultado);
  }

  private async getPerdaEspigasInteiras(): Promise<void> {
    const peso_espigas_inteiras_perdidas_kg: number = !!this.rs005CardIVComponent.formulario.get('Peso_espigas_inteiras_perdidas_kg').value ? (this.rs005CardIVComponent.formulario.get('Peso_espigas_inteiras_perdidas_kg')?.value as number ?? 0) : 0;
    const Peso_amostra_g: number = !!this.rs005CardIIIComponent.formulario.get('Peso_amostra_g').value ? (this.rs005CardIIIComponent.formulario.get('Peso_amostra_g')?.value as number ?? 0) : 0;
    let resultado: number = 0;
    if (peso_espigas_inteiras_perdidas_kg > 0 && Peso_amostra_g > 0) {
      resultado = this.generalService.CalcPorc(peso_espigas_inteiras_perdidas_kg, Peso_amostra_g);
    } else if (peso_espigas_inteiras_perdidas_kg >= 0 && Peso_amostra_g === 0) {
      resultado = 0;
    } else if (Peso_amostra_g >= 0 && peso_espigas_inteiras_perdidas_kg === 0) {
      resultado = 0;
    }

    this.rs005CardVComponent.formulario.get('Perda_espigas_inteiras').setValue(resultado);
  }

  private async getPerdaGraosDebulhadosDespalha(): Promise<void> {
    const perda_total_despalha: number = !!this.rs005CardVComponent.formulario.get('Perda_total_despalha').value ? (this.rs005CardVComponent.formulario.get('Perda_total_despalha')?.value as number ?? 0) : 0;
    const perda_espigas_inteiras: number = !!this.rs005CardVComponent.formulario.get('Perda_espigas_inteiras').value ? (this.rs005CardVComponent.formulario.get('Perda_espigas_inteiras')?.value as number ?? 0) : 0;
    let resultado: number = null;

    if (perda_total_despalha > 0 && perda_espigas_inteiras > 0) {
      resultado = perda_total_despalha - perda_espigas_inteiras;
    } else if (perda_total_despalha >= 0 && perda_espigas_inteiras == 0) {
      resultado = 0;
    } else if (perda_espigas_inteiras >= 0 && perda_total_despalha == 0) {
      resultado = 0;
    }

    this.rs005CardVComponent.formulario.get('Perda_graos_debulhados_despalha').setValue(resultado);
  }

  private async getPerdaTotalDespalha(): Promise<void> {
    const perda_processo_kg: number = !!this.rs005CardIVComponent.formulario.get('Perda_processo_kg').value ? (this.rs005CardIVComponent.formulario.get('Perda_processo_kg')?.value as number ?? 0) : 0;
    const peso_liquido_carga_umidade_kg: number = !!this.rs005CardIVComponent.formulario.get('Peso_liquido_carga_umidade_kg').value ? (this.rs005CardIVComponent.formulario.get('Peso_liquido_carga_umidade_kg')?.value as number ?? 0) : 0;
    let resultado: number = null;

    if (peso_liquido_carga_umidade_kg > 0 && perda_processo_kg > 0) {
      resultado = this.generalService.CalcPorc(perda_processo_kg, peso_liquido_carga_umidade_kg);
    }

    this.rs005CardVComponent.formulario.get('Perda_total_despalha').setValue(resultado);
  }

  private async getEspigasDespalhadasRetorno(): Promise<void> {
    const num_espigas_despalhadas_retorno: number = !!this.rs005CardVIComponent.formulario.get('Num_espigas_despalhadas_retorno').value ? (this.rs005CardVIComponent.formulario.get('Num_espigas_despalhadas_retorno')?.value as number ?? 0) : 0;
    const total_espigas_avaliadas_retorno: number = !!this.rs005CardVIComponent.formulario.get('Total_espigas_avaliadas_retorno').value ? (this.rs005CardVIComponent.formulario.get('Total_espigas_avaliadas_retorno')?.value as number ?? 0) : 0;
    let resultado: number = 0;

    if (total_espigas_avaliadas_retorno > 0) {
      resultado = this.generalService.CalcPorc(num_espigas_despalhadas_retorno, total_espigas_avaliadas_retorno);
    } else {
      resultado = 0;
    }

    this.rs005CardVIComponent.formulario.get('Espigas_despalhadas_retorno').setValue(resultado);
  }

  private async getEspigasPalhaMesa(): Promise<void> {
    const num_espigas_palha_mesa: number = !!this.rs005CardVIComponent.formulario.get('Num_espigas_palha_mesa').value ? (this.rs005CardVIComponent.formulario.get('Num_espigas_palha_mesa')?.value as number ?? 0) : 0;
    const total_espigas_avaliadas_mesa: number = !!this.rs005CardVIComponent.formulario.get('Total_espigas_avaliadas_mesa').value ? (this.rs005CardVIComponent.formulario.get('Total_espigas_avaliadas_mesa')?.value as number ?? 0) : 0;
    let resultado: number = 0;

    if (total_espigas_avaliadas_mesa > 0) {
      resultado = this.generalService.CalcPorc(num_espigas_palha_mesa, total_espigas_avaliadas_mesa);
    } else {
      resultado = 0;
    }
    this.rs005CardVIComponent.formulario.get('Espigas_palha_mesa').setValue(resultado);
  }

  private async getPesoLiqCargaSPalha(): Promise<void> {
    const peso_liq_carga_cooperante_kg: number = !!this.rs005CardIComponent.formulario.get('Peso_liq_carga_cooperante_kg').value ? (this.rs005CardIComponent.formulario.get('Peso_liq_carga_cooperante_kg')?.value as number ?? 0) : 0;
    const peso_palha_carga_kg: number = !!this.rs005CardIVComponent.formulario.get('Peso_palha_carga_kg').value ? (this.rs005CardIVComponent.formulario.get('Peso_palha_carga_kg')?.value as number ?? 0) : 0;
    const resultado: number = peso_liq_carga_cooperante_kg - peso_palha_carga_kg;
    this.rs005CardVIIComponent.formulario.get('Peso_liquido_carga_sem_palha_kg').setValue(resultado);
  }

  private async getPesoDescarteMesaSelecao(): Promise<void> {
    const peso_espigas_atipicas_kg: number = !!this.rs005CardVIIComponent.formulario.get('Peso_espigas_atipicas_kg').value ? (this.rs005CardVIIComponent.formulario.get('Peso_espigas_atipicas_kg')?.value as number ?? 0) : 0;
    const peso_espigas_fora_padrao_kg: number = !!this.rs005CardVIIComponent.formulario.get('Peso_espigas_fora_padrao_kg').value ? (this.rs005CardVIIComponent.formulario.get('Peso_espigas_fora_padrao_kg')?.value as number ?? 0) : 0;
    const resultado: number = peso_espigas_atipicas_kg + peso_espigas_fora_padrao_kg;
    this.rs005CardVIIComponent.formulario.get('Peso_descarte_mesa_selecao_kg').setValue(resultado);
  }

  private async getDescarteMesaSelecao(): Promise<void> {
    const peso_descarte_mesa_selecao_kg: number = !!this.rs005CardVIIComponent.formulario.get('Peso_descarte_mesa_selecao_kg').value ? (this.rs005CardVIIComponent.formulario.get('Peso_descarte_mesa_selecao_kg')?.value as number ?? 0) : 0;
    const peso_liquido_carga_sem_palha_kg: number = !!this.rs005CardVIIComponent.formulario.get('Peso_liquido_carga_sem_palha_kg').value ? (this.rs005CardVIIComponent.formulario.get('Peso_liquido_carga_sem_palha_kg')?.value as number ?? 0) : 0;
    let resultado: number = 0;

    if (peso_liquido_carga_sem_palha_kg > 0) {
      resultado = this.generalService.CalcPorc(peso_descarte_mesa_selecao_kg, peso_liquido_carga_sem_palha_kg);
    } else {
      resultado = 0;
    }
    this.rs005CardVIIComponent.formulario.get('Descarte_mesa_selecao').setValue(resultado);
  }

  private async getEspigasAtipicas(): Promise<void> {
    const peso_espigas_atipicas_kg: number = !!this.rs005CardVIIComponent.formulario.get('Peso_espigas_atipicas_kg').value ? (this.rs005CardVIIComponent.formulario.get('Peso_espigas_atipicas_kg')?.value as number ?? 0) : 0;
    const peso_liquido_carga_sem_palha_kg: number = !!this.rs005CardVIIComponent.formulario.get('Peso_liquido_carga_sem_palha_kg').value ? (this.rs005CardVIIComponent.formulario.get('Peso_liquido_carga_sem_palha_kg')?.value as number ?? 0) : 0;
    let resultado: number = 0;

    if (peso_liquido_carga_sem_palha_kg > 0) {
      resultado = this.generalService.CalcPorc(peso_espigas_atipicas_kg, peso_liquido_carga_sem_palha_kg);
    } else {
      resultado = 0;
    }

    this.rs005CardVIIComponent.formulario.get('Espigas_atipicas').setValue(resultado);
  }

  private async getDespalha(): Promise<void> {
    const numero_espigas_totais_contagem_1: number = !!this.rs005CardVIIIComponent.formulario.get('Numero_espigas_totais_contagem_1').value ? (this.rs005CardVIIIComponent.formulario.get('Numero_espigas_totais_contagem_1')?.value as number ?? 0) : 0;
    const numero_espigas_totais_contagem_2: number = !!this.rs005CardVIIIComponent.formulario.get('Numero_espigas_totais_contagem_2').value ? (this.rs005CardVIIIComponent.formulario.get('Numero_espigas_totais_contagem_2')?.value as number ?? 0) : 0;
    const numero_espigas_com_palha_contagem_1: number = !!this.rs005CardVIIIComponent.formulario.get('Numero_espigas_com_palha_contagem_1').value ? (this.rs005CardVIIIComponent.formulario.get('Numero_espigas_com_palha_contagem_1')?.value as number ?? 0) : 0;
    const numero_espigas_com_palha_contagem_2: number = !!this.rs005CardVIIIComponent.formulario.get('Numero_espigas_com_palha_contagem_2').value ? (this.rs005CardVIIIComponent.formulario.get('Numero_espigas_com_palha_contagem_2')?.value as number ?? 0) : 0;
    let resultado: number = 0;
    if ((numero_espigas_totais_contagem_1 + numero_espigas_totais_contagem_2) > 0) {
      resultado =

        this.generalService.CalcPorc(
          (numero_espigas_totais_contagem_1 + numero_espigas_totais_contagem_2) -
          (numero_espigas_com_palha_contagem_1 + numero_espigas_com_palha_contagem_2),
          (numero_espigas_totais_contagem_1 + numero_espigas_totais_contagem_2)
        );
    } else {
      resultado = 0;
    }
    this.rs005CardVIIIComponent.formulario.get('Despalha').setValue(resultado);
  }

  // private async getEspigasPalha(): Promise<void> {
  //     const numero_espigas_totais_contagem_1: number = !!this.rs005CardVIIIComponent.formulario.get('Numero_espigas_totais_contagem_1').value ? this.rs005CardVIIIComponent.formulario.get('Numero_espigas_totais_contagem_1')?.value as number ?? 0 : 0;
  //     const numero_espigas_totais_contagem_2: number = !!this.rs005CardVIIIComponent.formulario.get('Numero_espigas_totais_contagem_2').value ? this.rs005CardVIIIComponent.formulario.get('Numero_espigas_totais_contagem_2')?.value as number ?? 0 : 0;
  //     const numero_espigas_com_palha_contagem_1: number = !!this.rs005CardVIIIComponent.formulario.get('Numero_espigas_com_palha_contagem_1').value ? this.rs005CardVIIIComponent.formulario.get('Numero_espigas_com_palha_contagem_1')?.value as number ?? 0 : 0;
  //     const numero_espigas_com_palha_contagem_2: number = !!this.rs005CardVIIIComponent.formulario.get('Numero_espigas_com_palha_contagem_2').value ? this.rs005CardVIIIComponent.formulario.get('Numero_espigas_com_palha_contagem_2')?.value as number ?? 0 : 0;
  //     let resultado: number = 0;

  //     if (numero_espigas_totais_contagem_1 > 0 && numero_espigas_totais_contagem_2 > 0) {
  //         resultado = this.generalService.CalcPorc((
  //             (numero_espigas_com_palha_contagem_1 / numero_espigas_totais_contagem_1) +
  //             (numero_espigas_com_palha_contagem_2 / numero_espigas_totais_contagem_2)), 2)
  //     } else {
  //         resultado = 0;
  //     }
  //     this.rs005CardVIIIComponent.formulario.get('Espigas_palha').setValue(resultado);
  // }

  public async getDataFromCerar(cerar: string): Promise<void> {

    if (await this.checkCerarExist(cerar) == false) {
      await this.getQua007Data(cerar);
      await this.getRs009Data(cerar);
      await this.makeCalculations();
    }

  }
  async checkCerarExist(cerar): Promise<boolean> {

    if (this.id > 0) {
      return false;
    }



    try {
      const exist = await this.formularioService.checkCerarExist(cerar, this.rs005CardIComponent.formulario, 'rs005');

      return exist
    } catch (error) {
      this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar a umidade para o cerar ${cerar}. Entre em contato com o Administrador.`);

    }
    return true
  }
  private async getQua007Data(cerar: string): Promise<void> {
    await this.formularioService.getQua007Data(cerar).pipe(take(1)).toPromise().then((objQua007: any) => {
      this.rs005CardIComponent.formulario.get('Safra').setValue(objQua007?.data?.safra);
      this.rs005CardIComponent.formulario.get('Gleba').setValue(objQua007?.data?.gleba);
      this.rs005CardIComponent.formulario.get('Contrato_juridico').setValue(objQua007?.data?.contrato_juridico);
      this.rs005CardIComponent.formulario.get('Nr_campo').setValue(objQua007?.data?.numero_campo);
      this.rs005CardIComponent.formulario.get('Peso_liq_carga_cooperante_kg').setValue(objQua007?.data?.peso_liquido);
      this.rs005CardIComponent.formulario.get('Hibrido_rnc').setValue(objQua007?.data?.hibrido_rnc);
      this.rs005CardIIIComponent.formulario.get('Status_wwb').setValue(objQua007?.data?.status_wwb);
      this.rs005CardIXComponent.formulario.get('Linha_descarga').setValue(objQua007?.data?.linha_descarga);
      this.rs005CardVIIIComponent.formulario.get('Recobrimento_rolos').setValue(objQua007?.data?.recobrimento_rolos);
      this.rs005CardVIIIComponent.formulario.get('apc_ligado').setValue(objQua007?.data?.apc_ligado);
      this.formularioService.checkSiteRecebimento(objQua007?.data?.site_recebimento, this.rs005CardIComponent.formulario);
      console.log(objQua007)
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar os dados correspondentes ao cerar ${cerar}. Entre em contato com o Administrador.`);
    });
  }

  private async getRs009Data(cerar: string): Promise<void> {
    await this.formularioService.getRs009Info(cerar).pipe(take(1)).toPromise().then((objRs009: any) => {
      this.rs005CardIComponent.formulario.get('Peso_amostra_cooperante_g').setValue(objRs009?.data?.peso_amostra ?? 0);
      this.rs005CardIComponent.formulario.get('Peso_palha_cooperante_g').setValue(objRs009?.data?.palha ?? 0);
      this.rs005CardIComponent.formulario.get('Peso_impureza_cooperante_g').setValue(objRs009?.data?.impurezas ?? 0);
      this.rs005CardIComponent.formulario.get('Peso_sabugo_cooperante_g').setValue(objRs009?.data?.sabugo_milho ?? 0);
      this.rs005CardIComponent.formulario.get('Peso_semente_cooperante_g').setValue(objRs009?.data?.sementes ?? 0);
      this.rs005CardIComponent.formulario.get('Umidade').setValue(objRs009?.data?.umidade ?? 0);
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar os dados correspondentes ao cerar ${cerar}. Entre em contato com o Administrador.`);
    });
  }

  private async getUser(): Promise<void> {
    await this.formularioService.getUser().pipe(take(1)).toPromise().then(response => {
      this.rs005CardIXComponent.formulario.get('Responsavel_lancamento').setValue(response['user-profile']?.displayName ?? 'Administrador');
      this.currentUser = response['user-profile']?.displayName ?? 'Administrador';
    }).catch(async error => {
      await this.generalService.getUserNameValue().pipe(take(1)).toPromise().then((response: string) => {
        this.rs005CardIXComponent.formulario.get('Responsavel_lancamento').setValue(response ?? 'Administrador');
        this.currentUser = response ?? 'Administrador';
      }).catch(err => {
      });
    });
  }

  private fillCreatedByFormField(): void {
    this.rs005CardIXComponent.formulario.get('criado_por').setValue(this.currentUser);
    this.rs005CardVIIComponent.formulario?.get('created_by').setValue(this.currentUser);
  }

  setIsG0() {
    if (this.rs005CardIComponent.formulario?.get('geracao').value === 'G0') {
      this.rs005CardIIComponent.isSourceEnable = true;
      this.rs005CardIVComponent.isG0 = true;
      this.rs005CardIVComponent.formulario?.get('lote_pa').setValidators(Validators.required);
      this.rs005CardIVComponent.formulario?.get('peso_pa_bruto').setValidators(Validators.required);
      this.rs005CardIVComponent.formulario?.get('peso_pa_liquido').setValidators(Validators.required);
      this.rs005CardIVComponent.formulario?.get('descarte_pa').setValidators(Validators.required);
      this.rs005CardIVComponent.formulario?.get('numero_sacos').setValidators(Validators.required);
    } else {
      this.rs005CardIVComponent.isG0 = false;
      this.rs005CardIVComponent.formulario?.get('lote_pa').setValidators([]);
      this.rs005CardIVComponent.formulario?.get('peso_pa_bruto').setValidators([]);
      this.rs005CardIVComponent.formulario?.get('peso_pa_liquido').setValidators([]);
      this.rs005CardIVComponent.formulario?.get('descarte_pa').setValidators([]);
      this.rs005CardIVComponent.formulario?.get('numero_sacos').setValidators([]);
    }
  }

  setSourceValid($event) {
    if (this.rs005CardIComponent.formulario?.get('geracao').value === 'G0') {
      this.rs005CardIIComponent.isSourceEnable = true;
      this.rs005CardIVComponent.isG0 = true;
      this.rs005CardIVComponent.formulario?.get('lote_pa').setValidators(Validators.required);
      this.rs005CardIVComponent.formulario?.get('peso_pa_bruto').setValidators(Validators.required);
      this.rs005CardIVComponent.formulario?.get('peso_pa_liquido').setValidators(Validators.required);
      this.rs005CardIVComponent.formulario?.get('descarte_pa').setValidators(Validators.required);
      this.rs005CardIVComponent.formulario?.get('numero_sacos').setValidators(Validators.required);
    }
    else {
      this.rs005CardIVComponent.isG0 = false;
      this.rs005CardIVComponent.formulario?.get('lote_pa').setValidators([]);
      this.rs005CardIVComponent.formulario?.get('peso_pa_bruto').setValidators([]);
      this.rs005CardIVComponent.formulario?.get('peso_pa_liquido').setValidators([]);
      this.rs005CardIVComponent.formulario?.get('descarte_pa').setValidators([]);
      this.rs005CardIVComponent.formulario?.get('numero_sacos').setValidators([]);
    }

    this.rs005CardIIComponent.dataHoraSecagem = this.generalService.createDateTimeData($event.result.data.amostragem_data_fim, $event.result.data.amostragem_hora_fim);
    this.rs005CardIIComponent.pesoPosSecagem = $event.pesoPosSecagem;
  }

  changeCaixaPosMesa($event) {
    this.rs005CardIVComponent.formulario?.get('numero_caixa').setValue(this.rs005CardIIComponent.formulario?.get('caixa_pos_mesa').value);
  }

  onChangeDatesPreBasica($event) {
    //Seleção Horas
    if (this.rs005CardIIComponent.formulario?.get('inicio_selecao_data').value &&
      this.rs005CardIIComponent.formulario?.get('inicio_selecao_hora').value &&
      this.rs005CardIIComponent.formulario?.get('fim_selecao_data').value &&
      this.rs005CardIIComponent.formulario?.get('fim_selecao_hora').value) {
      var dateInit = this.generalService.createDateTimeData(this.rs005CardIIComponent.formulario?.get('inicio_selecao_data').value, this.rs005CardIIComponent.formulario?.get('inicio_selecao_hora').value);
      var dateEnd = this.generalService.createDateTimeData(this.rs005CardIIComponent.formulario?.get('fim_selecao_data').value, this.rs005CardIIComponent.formulario?.get('fim_selecao_hora').value);
      this.rs005CardVIComponent.formulario?.get('selecao_horas').setValue(Math.abs(dateEnd - dateInit) / 36e5);
    }

    //Debulha Horas
    if (this.rs005CardIVComponent.formulario?.get('inicio_debulha_data').value &&
      this.rs005CardIVComponent.formulario?.get('inicio_debulha_hora').value &&
      this.rs005CardIVComponent.formulario?.get('fim_debulha_data').value &&
      this.rs005CardIVComponent.formulario?.get('fim_debulha_hora').value) {
      var dateInit = this.generalService.createDateTimeData(this.rs005CardIVComponent.formulario?.get('inicio_debulha_data').value, this.rs005CardIVComponent.formulario?.get('inicio_debulha_hora').value);
      var dateEnd = this.generalService.createDateTimeData(this.rs005CardIVComponent.formulario?.get('fim_debulha_data').value, this.rs005CardIVComponent.formulario?.get('fim_debulha_hora').value);
      this.rs005CardVIComponent.formulario?.get('debulhas_horas').setValue(Math.abs(dateEnd - dateInit) / 36e5);

    }

    //Tempo de atraso (secagem - seleção)
    if (this.rs005CardIIComponent.formulario?.get('inicio_selecao_data').value &&
      this.rs005CardIIComponent.formulario?.get('inicio_selecao_hora').value &&
      this.rs005CardIIComponent.dataHoraSecagem
    ) {
      var dateInit = this.generalService.createDateTimeData(this.rs005CardIIComponent.formulario?.get('inicio_selecao_data').value, this.rs005CardIIComponent.formulario?.get('inicio_selecao_hora').value);
      this.rs005CardVIComponent.formulario?.get('tempo_atraso_secagem').setValue(Math.abs(dateInit - this.rs005CardIIComponent.dataHoraSecagem) / 36e5);
    }

    //Tempo de atraso (seleção - debulha)
    if (this.rs005CardIIComponent.formulario?.get('fim_selecao_data').value &&
      this.rs005CardIIComponent.formulario?.get('fim_selecao_hora').value &&
      this.rs005CardIVComponent.formulario?.get('inicio_debulha_data').value &&
      this.rs005CardIVComponent.formulario?.get('inicio_debulha_hora').value) {
      var fim_selecao = this.generalService.createDateTimeData(this.rs005CardIIComponent.formulario?.get('fim_selecao_data').value, this.rs005CardIIComponent.formulario?.get('fim_selecao_hora').value);
      var inicio_debuha = this.generalService.createDateTimeData(this.rs005CardIVComponent.formulario?.get('inicio_debulha_data').value, this.rs005CardIVComponent.formulario?.get('inicio_debulha_hora').value);
      this.rs005CardVIComponent.formulario?.get('tempo_atraso_selecao').setValue(Math.abs(inicio_debuha - fim_selecao) / 36e5);
    }

    //Tempo de parada seleção
    this.rs005CardVIComponent.formulario?.get('tempo_parada_selecao').setValue(this.rs005CardIIComponent.formulario?.get('tempo_parada_selecao_hora').value);
    //Tempo de parada debulha
    this.rs005CardVIComponent.formulario?.get('tempo_parada_debulha').setValue(this.rs005CardIVComponent.formulario?.get('tempo_parada_debulha_hora').value);
  }

  public createSourceCardIItemCompoment(data: any): void {
    if (!!data.formulario?.list_source) {
      const totalItens: number = data.formulario.list_source?.length;

      for (let j = 0; j < totalItens; j++) {
        this.rs005CardIIComponent.createSourceItemComponent();
      }

      if (this.rs005CardIIComponent.VCR.length < 1) return;

      for (let key = 0; key < totalItens; key++) {
        let componentRef = this.rs005CardIIComponent.sourceItemReferences.filter(x => x.instance.unique_key == key)[0];
        componentRef.instance.formulario.get('id').setValue(data.formulario.list_source[key].id);
        componentRef.instance.formulario.get('source').setValue(data.formulario.list_source[key].source);
        componentRef.instance.formulario.get('lote').setValue(data.formulario.list_source[key].lote);
      }
    }
  }

  private buildListSource(rs_id: number): void {
    const sourceList: Rs005SourceItem[] = [];
    this.rs005CardIIComponent.sourceItemReferences.forEach(element => {
      sourceList.push({
        id: element.instance.formulario?.get('id').value,
        rs005_id: rs_id,
        source: element.instance.formulario?.get('source').value,
        lote: element.instance.formulario?.get('lote').value
      })
    })

    this.formulario?.get('list_source').setValue(sourceList);
  }
}

